module.exports = __webpack_public_path__ + "static/category-28c2eb4dd03de0925c88709ef8c0c833.png";